<section class="container sign-container login-container sponsor-page" id="logIn">
    <img class="sign-in-background" src="../../../assets/img/{{themeService.theme}}/zp-lg-background.png" alt="">
    <section class="navbar-brand">
        <img src="../../assets/img/{{themeService.theme}}/scd-logo.png" alt="Company Logo" width="125px">
    </section>
    <!-- <div class="sign-account" [routerLink]="['/sign-up']">Don't have an account? Sign Up</div> -->
    <section class="container">
        <h1 class="serif-title">Welcome to Zenplans</h1>
        <app-notification-bubble></app-notification-bubble>
        <section class="sign-get-info">
            <section class="form-group">
                <div class="img">
                    <div *ngIf="professionalLogo==false"></div>
                    <img *ngIf="professionalLogo==true" src="{{logoUrl}}" alt="{{company}}" width="150px">
                </div>
                <div *ngIf="displayPrePopulateText==false && companyDetails && 
                                companyDetails.firstName && 
                                companyDetails.lastName && 
                                companyDetails.company" class="company-name">
                    {{firstName + ' ' + lastName}} from {{company}} has invited you to create your Zenplan.
                </div>
                <div *ngIf="displayPrePopulateText==true && companyDetails && 
                                companyDetails.firstName && 
                                companyDetails.lastName && 
                                companyDetails.company" class="company-name">
                    {{firstName + ' ' + lastName}} from {{company}} has created an account for you.
                </div>
                <input type="button" value="Get Started" class="form-control btn btn-primary primary-default-btn"
                    (click)="finishSignup()">
            </section>
        </section>
    </section>
</section>
<app-footer></app-footer>